import { Box, Button, Card, CardBody, CardHeader, CheckBox, FormField, Heading, Image, Markdown, Notification, RadioButtonGroup, Text, TextInput } from "grommet"
import { Trans, useTranslation } from "react-i18next";
import { DonatelloSettings } from "../components/auc-settings/DonatelloSettings";
import { DonatikSettings } from "../components/auc-settings/DonatikSettings";
import { MonobankSettings } from "../components/auc-settings/MonobankSettings";
import { Clear, Connect, Copy, Detach, Download, Share, Update, Upload } from "grommet-icons";
import { formattedPrice } from "../utils/priceUtils";
import { Suspense, useState } from "react";
import { DonatelloPaymentMethodCard } from "../components/payment-options/DonatelloPaymentMethodCard";
import { DonatikPaymentMethodCard } from "../components/payment-options/DonatikPaymentMethodCard";
import { MonobankPaymentMethodCard } from "../components/payment-options/MonobankPaymentMethodCard";
import { useGetPaymentOptionsQuery } from "../api/paymentOptionsApi";

export const PaymentMethodsPage = () => {

    const { t, ready } = useTranslation('settings', 'donatello-settings', {
        useSuspense: false,
    });

    const { data: paymentOptions, isSuccess: isLoadedPaymentOptions } = useGetPaymentOptionsQuery();

    if (ready) {
        return (
            <Box gap="medium">
                <Card>
                    <CardBody gap="small">
                        <Heading level={3} margin={'none'}>{t('paymentMethodsTitle')}</Heading>
                    </CardBody>
                </Card>

                <Suspense fallback={<div>Loading...</div>}>
                    <Box gap="medium">
                        {isLoadedPaymentOptions && paymentOptions.map(paymentOption => (
                            paymentOption.type === 'DONATELLO' && <DonatelloPaymentMethodCard apiKey={paymentOption.apiKey} nickname={paymentOption.donateSystemNickname} helpLink={paymentOption.helpLink} enabled={paymentOption.enabled} /> 
                            || paymentOption.type === 'DONATIK' && <DonatikPaymentMethodCard apiKey={paymentOption.apiKey} nickname={paymentOption.donateSystemNickname} helpLink={paymentOption.helpLink} enabled={paymentOption.enabled} />
                            || paymentOption.type === 'MONOBANK' && <MonobankPaymentMethodCard title={paymentOption.title} sendId={paymentOption.sendId} helpLink={paymentOption.helpLink} enabled={paymentOption.enabled} />
                        ))}
                    </Box>
                </Suspense>
            </Box>
        )
    }
}